import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import "swiper/css";
import "swiper/css/navigation";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

import building from "../image/building.png";
// import building2 from "../image/building2.png";

import testimonials from "../image/testimonials1.png";
import ganeshUser from "../image/ganesh-user1.png";
import kalidasUser from "../image/kalidas-user1.png";

import icon1 from "../image/icon1.png";
import icon2 from "../image/icon2.png";
import icon3 from "../image/timely-icon.png";
import icon4 from "../image/icon4.png";

import ser1 from "../image/ser1.png";
import serTurnkey from "../image/ser-turnkey.png";
import ser4 from "../image/ser4.png";
import liasoningImg from "../image/service-image/liasoning-image.png";
import pmcImg from "../image/bungalow-bg.png2.png";

import icon100 from "../image/Icons/100+.png";
import icon50 from "../image/Icons/50+.png";
import iconProjects from "../image/Icons/projects.png";
import iconCities from "../image/Icons/cites.png";
// import ReviewSection from "./ReviewSection";
import homeProjectCover from "../image/project-showcase/showcase-18.png";
// import Gallery from "./Gallery";
import BeforeAfter from "./BeforeAfter";
import ProjectsGrid from "../components/ProjectsGrid";


// function DwServicesCarousel() {

//   const services = [
//     {
//       title: "Architecture Design Services",
//       desc: "Personalized home designs that are beautiful, functional and practical.",
//       img: "/image/service1.jpeg",
//     },
//     {
//       title: "Liasioning – Design approvals",
//       desc: "We take care of all necessary permissions from PMC, PCMC, and PMRDA.",
//       img: "/image/service2.webp",
//     },
//     {
//       title: "Complete Turnkey Construction Solutions",
//       desc: "Quality construction with attention to detail.",
//       img: "/image/service3.webp",
//     },
//     {
//       title: "Interior Design Services",
//       desc: "From cozy living rooms to smart kitchens, we bring your interiors to life.",
//       img: "/image/service4.webp",
//     }
//   ];

//   const sliderRef = useRef(null);

//   const scrollLeft = () => {
//     sliderRef.current.scrollBy({
//       left: -420,
//       behavior: "smooth"
//     });
//   };

//   const scrollRight = () => {
//     sliderRef.current.scrollBy({
//       left: 420,
//       behavior: "smooth"
//     });
//   };

//   return (
//     <section className="dwsc-section">
//       <div className="dwsc-container">

//         <h2 className="dwsc-heading">Our Services</h2>

//         <div className="dwsc-slider-wrapper">

//           <div ref={sliderRef} className="dwsc-scroll">
//             {services.map((item, i) => (
//               <div className="dwsc-card" key={i}>
//                 <div className="dwsc-img">
//                   <img src={item.img} alt={item.title} />
//                 </div>
//                 <div className="dwsc-content">
//                   <h3>{item.title}</h3>
//                   <p>{item.desc}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="dwsc-nav-bottom">
//             <button className="dwsc-nav" onClick={scrollLeft}>←</button>
//             <button className="dwsc-nav" onClick={scrollRight}>➝</button>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }


function Home({ openContactModal, openMeetingModal, showCTA })

 {

  const navigate = useNavigate();

const nextStep = () => {
  if (!data.openPlot && !data.nonApprovedProperty) {
    alert("Select property type");
    return;
  }

  if (data.openPlot && !data.areaInputType) {
    alert("Select area type");
    return;
  }

  if (data.nonApprovedProperty) {
    if (!data.society || !data.plot || !data.buildingType) {
      alert("Fill all fields");
      return;
    }
  }

  localStorage.setItem("estimateData", JSON.stringify(data));
  navigate("/estimate");
};

const [data, setData] = useState({
  openPlot: false,
  nonApprovedProperty: false,
  areaInputType: "",
  openPlotLength: "",
  openPlotWidth: "",
  openPlotArea: "",
  openPlotLengthWidthUnit: "Feet",
  openPlotAreaUnit: "sq.ft",
  society: "",
  plot: "",
  buildingType: ""
});

const handle = (e) => {
  setData({
    ...data,
    [e.target.name]: e.target.value
  });
};

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }, [location]);

  
  // const splideRef = useRef(null);

  // const videoData = [
  //   { id: 1, video: "image/video1.mp4", text: "Modular Kitchen Work" },
  //   { id: 2, video: "image/video2.mp4", text: "TV Unit Design" },
  //   { id: 3, video: "image/video3.mp4", text: "Bedroom Interior" },
  //   { id: 4, video: "image/video1.mp4", text: "Living Room Design" },
  // ];

  // stop all videos
  // const stopAllVideos = () => {
  //   document.querySelectorAll(".dw-video-slide video").forEach((video) => {
  //     video.pause();
  //     video.currentTime = 0;
  //   });

  //   document.querySelectorAll(".dw-video-play-btn").forEach((btn) => {
  //     btn.style.display = "block";
  //   });
  // };

  // play only active video
  // const playActiveVideo = (e) => {
  //   e.stopPropagation();

  //   stopAllVideos();

  //   const slide = e.target.closest(".dw-video-slide");
  //   if (!slide) return;

  //   const video = slide.querySelector("video");
  //   const btn = slide.querySelector(".dw-video-play-btn");

  //   if (video) video.play();
  //   if (btn) btn.style.display = "none";
  // };

  // TYPEWRITER TEXT
  const fullText = "Our Customers Reviews";
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);


// const reviewData = [
//   {
//     id: 1,
//     name: "Dr. Kalidas Sendkar",
//     text: "Dwellora Homes exceeded our expectations with exceptional design, innovation,and professionalism. From layout to interiors, they crafted a bright, modern home that blends style with function. Their team was creative, committed, and delivered everything seamlessly.",
//     img: "image/kalidas-user.webp"
//   },
//   {
//     id: 2,
//     name: "Mr. Pranav Khot",
//     text: "I recently got my home interiors done by Dwellora Design LLP, and the experience was outstanding. Since I was at my native place, I gave the team complete authority to handle the entire design and execution. I saw the final work just a day before my housewarming—and I was genuinely surprised and impressed by the results. The design, quality, and finishing were far beyond my expectations. Truly reliable and professional team. Highly recommended!.",
//     img: "image/testimonials.png"
//   },
//   {
//     id: 3,
//     name: "Mr. Ganesh Eklare",
//     text: "Dwellora Design LLP delivered an excellent experience for my project. They truly are a one-stop solution—handling design, liasoning/sanction work, and construction smoothly under one roof. The team was professional, transparent, and easy to work with. Their guidance and timely updates made the entire process hassle-free. Highly recommended for anyone looking for complete end-to-end services.",
//     img: "image/ganesh-eklare-user.webp"
//   }
// ];

const reviewData = [
  {
    id: 1,
   
 name: "Mr. Pranav Khot",
    text: "I recently got my home interiors done by Dwellora Design LLP, and the experience was outstanding. Since I was at my native place, I gave the team complete authority to handle the entire design and execution. I saw the final work just a day before my housewarming—and I was genuinely surprised and impressed by the results. The design, quality, and finishing were far beyond my expectations. Truly reliable and professional team. Highly recommended!.",
    img: testimonials

  },
  {
    id: 2,
    name: "Dr. Kalidas Sendkar",
    text: "Dwellora Homes exceeded our expectations with exceptional design, innovation,and professionalism. From layout to interiors, they crafted a bright, modern home that blends style with function. Their team was creative, committed, and delivered everything seamlessly.",
    img: kalidasUser

  },
  {
    id: 3,
    name: "Mr. Ganesh Eklare",
    text: "Dwellora Design LLP delivered an excellent experience for my project. They truly are a one-stop solution—handling design, liasoning/sanction work, and construction smoothly under one roof. The team was professional, transparent, and easy to work with. Their guidance and timely updates made the entire process hassle-free. Highly recommended for anyone looking for complete end-to-end services.",
    img: ganeshUser
  }
];


  // Splide Options
  // const splideOptions = {
  //   type: "loop",
  //   perPage: 1,
  //   focus: "center",
  //   gap: "-15px",
  //   pagination: false,
  //   arrows: true,
  //   trimSpace: false,
  //   padding: "22%",

  //   breakpoints: {
  //     991: {
  //       padding: "15%",
  //       gap: "20px",
  //     },
  //     576: {
  //       perPage: 1,
  //       padding: "0%",
  //       gap: "0px",
  //       focus: "center",
  //     },
  //   },
  // };

  // Typewriter Effect
  useEffect(() => {
    const speed = isDeleting ? 50 : 100;

    const timer = setTimeout(() => {
      if (!isDeleting) {
        setText(fullText.substring(0, index + 1));
        setIndex(index + 1);

        if (index + 1 === fullText.length) {
          setTimeout(() => setIsDeleting(true), 1200);
        }
      } else {
        setText(fullText.substring(0, index - 1));
        setIndex(index - 1);

        if (index - 1 === 0) {
          setIsDeleting(false);
        }
      }
    }, speed);

    return () => clearTimeout(timer);
  }, [index, isDeleting]);

  // Achievenment section)
useEffect(() => {
  const items = document.querySelectorAll(".achievements-section .dw-ach-item");
  let current = 0;

  if (!items.length) return;

  const interval = setInterval(() => {
    items.forEach((item) => {
      item.classList.remove("active");

      const oldBox = item.querySelector(".dw-corner-box");
      if (oldBox) oldBox.remove();
    });

    items[current].classList.add("active");

    const box = document.createElement("span");
    box.className = "dw-corner-box";

    const tr = document.createElement("span");
    tr.className = "tr";

    const bl = document.createElement("span");
    bl.className = "bl";

    box.appendChild(tr);
    box.appendChild(bl);

    items[current].prepend(box);

    current++;
    if (current >= items.length) current = 0;
  }, 900);

  return () => clearInterval(interval);
}, []);


useEffect(() => {
  const section = document.querySelector(".dw-quote-section");

  if (!section) return;   

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(section);

  return () => {
    observer.unobserve(section);
    observer.disconnect();
  };
}, []);

useEffect(() => {
  const sections = document.querySelectorAll(".animate-corner");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        } else {
          entry.target.classList.remove("active"); 
        }
      });
    },
    { threshold: 0.4 }
  );

  sections.forEach((sec) => observer.observe(sec));

  return () => observer.disconnect();
}, []);


useEffect(() => {
  let serviceSwiper;

  const initSwiper = () => {
    if (window.innerWidth >= 768) {
      serviceSwiper = new Swiper(".dw-service-swiper", {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 25,
        loop: true,
        loopedSlides: 5,
        speed: 800,
        navigation: {
          nextEl: ".dw-service-next",
          prevEl: ".dw-service-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 25,
          },
        },
      });
    }
  };

  initSwiper();

  return () => {
    if (serviceSwiper) {
      serviceSwiper.destroy(true, true);
    }
  };
}, []);

useEffect(() => {
  //  Mobile view me animation disable
  if (window.innerWidth <= 768) return;

  const section = document.querySelector(".dw-difference-section");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {

        const cards = entry.target.querySelectorAll(".dw-difference-card");
        const vs = entry.target.querySelector(".dw-difference-vs-wrapper");

        if (entry.isIntersecting) {

          let delay = 0;

          cards.forEach((card, index) => {
            setTimeout(() => {
              card.classList.add("show");

              if (index === cards.length - 1) {
                setTimeout(() => {
                  vs.classList.add("show");
                }, 200);
              }

            }, delay);

            delay += 100;
          });

        } else {
          cards.forEach(card => card.classList.remove("show"));
          vs.classList.remove("show");
        }

      });
    },
    { threshold: 0.4 }
  );

  if (section) observer.observe(section);

  return () => observer.disconnect();

}, []);

  return (
    <>
 <div className="home-page">

      {/* Hero */}
      <section className="hero">
        <div className="hero-bg"></div>

        <div className="container-fluid h-100 ">
          <div className="row h-100 g-0">
            <div className="col-lg-7 col-md-7">
              <div className="hero-text" data-aos="fade-right">
                <h1>
                  India's First <br />
                  Construction Company <br />
                  Offering Real-Time <br />
                  Site Monitoring
                </h1>

                <p>
                  Track your site progress with Live Camera Access <br />
                  100% Transparency Zero Surprises
                </p>

                <button onClick={openContactModal} className="hero-btn">
  <span className="btn-text">Let’s Consult</span>
  <span className="btn-arrow">&#x203A;</span>
</button>


                <div className="hero-testimonial d-flex align-items-center mt-4">
                  <div className="avatar-group d-flex align-items-center">
                    {/* <img src="image/testimonials.png" className="avatar-img" alt="" />
                    <img src="image/ganesh-eklare-user.webp" className="avatar-img" alt="" />
                    <img src="image/kalidas-user.webp" className="avatar-img" alt="" /> */}

<img src={testimonials} className="avatar-img" alt="" />
<img src={ganeshUser} className="avatar-img" alt="" />
<img src={kalidasUser} className="avatar-img" alt="" />


                    <div id="customerCount" className="testimonial-count avatar-img">
                      100+
                    </div>
                  </div>

                  <div className="testimonial-text ms-3">
                    Valuable<br />Customers
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-5 hero-image" data-aos="fade-left">
              {/* <img src="image/building.png" alt="Building" /> */}
              <img src={building} alt="Dwellora Homes building" />
            </div>
          </div>
        </div>
      </section>

 

     
{/* Achievements */}
{/* <section className="achievements-section">
  <div className="container">
    <div className="row align-items-center">

      <div className="col-lg-6">
        <h2 className="ach-title">
          Over a Decade of<br />
          Achievements
        </h2>
      </div>

      <div className="col-lg-6">
        <div className="row">

          <div className="col-6 mb-4">
            <div className="ach-item">
              <img src="image/Icons/100+.png" alt="" />
              <div>
                <h4>100+</h4>
                <p>Satisfied Clients</p>
              </div>
            </div>
          </div>

          <div className="col-6 mb-4">
            <div className="ach-item">
              <img src="image/Icons/50+.png" alt="" />
              <div>
                <h4>50+</h4>
                <p>Skilled Workers</p>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="ach-item">
              <img src="image/Icons/projects.png" alt="" />
              <div>
                <h4>50+</h4>
                <p>Projects Completed</p>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="ach-item">
              <img src="image/Icons/cites.png" alt="" />
              <div>
                <h4>5</h4>
                <p>Cities</p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</section> */}

{/* Achievements */}
<section className="achievements-section">
  <div className="container">
    <div className="row align-items-center">

      <div className="col-lg-6">
        <h2 className="ach-title">
          Over a Decade of<br />
          Achievements
        </h2>
      </div>

      <div className="col-lg-6">
        <div className="row">

          <div className="col-6 mb-4">
            <div className="ach-item dw-ach-item">
              {/* <img src="image/Icons/100+.png" alt="" /> */}
              <img src={icon100} alt="" />
              <div>
                <h4>100+</h4>
                <p>Satisfied Clients</p>
              </div>
            </div>
          </div>

          <div className="col-6 mb-4">
            <div className="ach-item dw-ach-item">
              {/* <img src="image/Icons/50+.png" alt="" /> */}
              <img src={icon50} alt="" />
              <div>
                <h4>50+</h4>
                <p>Skilled Workers</p>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="ach-item dw-ach-item">
              {/* <img src="image/Icons/projects.png" alt="" /> */}
<img src={iconProjects} alt="" />

              <div>
                <h4>50+</h4>
                <p>Projects Completed</p>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="ach-item dw-ach-item">
              {/* <img src="image/Icons/cites.png" alt="" /> */}
              <img src={iconCities} alt="" />
              <div>
                <h4>5</h4>
                <p>Cities</p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</section>

{/* <section className="dw-home-projects-section">
  <div className="container">
    <div className="dw-home-projects-grid">
      <div className="dw-home-projects-copy">
        <h2>
          Built with vision. Delivered with <span>excellence.</span>
        </h2>
        <p>
          Discover exceptional architecture, interior, and construction
          projects that define quality living.
        </p>

        <Link to="/projects" className="dw-home-projects-btn">
          View Our Projects
          
          <span className="btn-arrow">&#x203A;</span>
        </Link>

        <div className="dw-home-projects-services" aria-label="Project categories">
          <div className="dw-home-projects-service">
            <i className="bi bi-house-door" aria-hidden="true"></i>
            <span>Residential<br />Projects</span>
          </div>

          <div className="dw-home-projects-service">
            <i className="bi bi-buildings" aria-hidden="true"></i>
            <span>Commercial<br />Spaces</span>
          </div>

          <div className="dw-home-projects-service">
            <i className="bi bi-palette" aria-hidden="true"></i>
            <span>Interior<br />Designs</span>
          </div>

          <div className="dw-home-projects-service">
            <i className="bi bi-gear-wide-connected" aria-hidden="true"></i>
            <span>Turnkey<br />Solutions</span>
          </div>
        </div>
      </div>

      <div className="dw-home-projects-preview" aria-label="Project preview">
        <img
          src={homeProjectCover}
          alt="Residential facade project"
          className="dw-home-projects-main-img"
        />
      </div>
    </div>
  </div>
</section> */}

{/* <Gallery/> */}

<BeforeAfter/>



   {/* what make dwellora different section */}
<section className="dw-difference-section">
  <div className="container">

    <h2 className="dw-difference-heading text-center">
      What Makes Dwellora Homes Different
    </h2>

    <div className="row dw-difference-row">

      {/* LEFT */}
      <div className="col-lg-5">
        <h5 className="dw-difference-subheading">Dwellora Homes</h5>

        <div className="dw-difference-card dw-difference-card-left">
          <div className="dw-difference-icon dw-difference-icon-green">✓</div>
          <div className="dw-difference-text">
            <h6>24/7 Live Site Monitoring</h6>
            <p>Real-time camera access</p>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-left">
          <div className="dw-difference-icon dw-difference-icon-green">✓</div>
          <div className="dw-difference-text">
            <h6>Design + Approvals + Build</h6>
            <p>All done in-house — no third parties</p>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-left">
          <div className="dw-difference-icon dw-difference-icon-green">✓

          </div>
          <div className="dw-difference-text">
            <h6>Smart Pricing Starts at ₹1250/Sq.ft</h6>
            <p>
              Includes Grey Construction (RCC + Brickwork + Plaster), Architectural Design & Liaisoning Approvals

            </p>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-left">
          <div className="dw-difference-icon dw-difference-icon-green">✓</div>
          <div className="dw-difference-text">
            <h6>Material Testing Reports</h6>
            <p>Shared directly with clients</p>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-left">
          <div className="dw-difference-icon dw-difference-icon-green">✓</div>
          <div className="dw-difference-text">
            <h6>Architect + Civil Experts</h6>
            <p>10+ years leadership experience</p>
          </div>
        </div>
      </div>

      {/* CENTER VS */}
      <div className="col-lg-2 d-flex justify-content-center align-items-center dw-diff-center">
        <div className="dw-difference-vs-wrapper">
          <span className="dw-difference-vs-text">VS</span>
        </div>
      </div>

      {/* RIGHT */}
      <div className="col-lg-5">
        <h5 className="dw-difference-subheading">
          Typical Construction Companies
        </h5>

        <div className="dw-difference-card dw-difference-card-right">
          <div className="dw-difference-icon dw-difference-icon-red">✕</div>
          <div className="dw-difference-text">
            <h6>Live Site Monitoring is Not Available</h6>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-right">
          <div className="dw-difference-icon dw-difference-icon-red">✕</div>
          <div className="dw-difference-text">
            <h6>Approvals & build often outsourced</h6>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-right">
          <div className="dw-difference-icon dw-difference-icon-red">✕</div>
          <div className="dw-difference-text">
            <h6>Fragmented Costs</h6>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-right">
          <div className="dw-difference-icon dw-difference-icon-red">✕</div>
          <div className="dw-difference-text">
            <h6>No Quality Proof checks</h6>
          </div>
        </div>

        <div className="dw-difference-card dw-difference-card-right">
          <div className="dw-difference-icon dw-difference-icon-red">✕</div>
          <div className="dw-difference-text">
            <h6>Varies, mostly third-party teams</h6>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
{/* what make dwellora different section END */}



      {/* Why Section */}
      <section className="why-section">
        <div className="container">
          <h2>Why Families Choose Dwellora?</h2>

          <div className="row">
            <div className="col-lg-6 mb-4">
              <div className="why-card-item">
               <img src={icon1} alt="" />
                <div>
                  <h5>Quality Construction</h5>
                  <p>
                    At Dwellora, quality isn’t a claim — it’s proven. With certified
                    material testing, skilled labour, and on-site supervision, we
                    ensure every detail meets the highest standards.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mb-4">
              <div className="why-card-item">
                <img src={icon2} alt="" />
                <div>
                  <h5>Smart Pricing</h5>
                  <p>
                    Premium quality construction starting at ₹1250/Sq.Ft.
                    Transparent pricing with no hidden costs.
                  </p>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-6 mb-4">
              <div className="why-card-item">
               <img src={icon3} alt="" />
                <div>
                  <h5>Expert Leadership</h5>
                  <p>
                    Led by our Founder-CEO, an architect & civil engineer partner,
                    bringing 25+ years of experience.
                  </p>
                </div>
              </div>
            </div> */}

             

            <div className="col-lg-6 mb-4">
              <div className="why-card-item">
              <img src={icon4} alt="" />
                <div>
                  <h5>One-Stop Solution</h5>
                  <p>
                    From design approvals to construction execution — everything
                    handled in-house. No middlemen.
                  </p>
                </div>
              </div>
            </div>

<div className="col-lg-6 mb-4">
              <div className="why-card-item">
               <img src={icon3} alt="" />
                <div>
                  <h5>Assured Timely Delivery</h5>
                  <p>
                    We ensure your project is completed on schedule through careful planning and efficient execution.
                  </p>
                </div>
              </div>
            </div>

          </div>

          <div className="text-center">
            <button onClick={openMeetingModal} className="why-btn">
              Book a Meeting
            </button>
          </div>
        </div>
      </section>


        {/* QUOTE SECTION */}
      <section className="dw-quote-section">
        <div className="container">
          <div className="row dw-quote-row">
            <div className="col-lg-7 mb-5">
              <div className="dw-quote-content">
                <h2 className="dw-quote-heading">
                  Customize Your Quote
                  Accurate, Transparent & Instant
                </h2>

                <p className="dw-quote-para">
                  Use our smart estimator to get a quick, transparent quote based on your
                  requirements — no hidden charges, no guesswork.
                </p>

              <div className="row dw-quote-list gx-5">

  <div className="col-12">
    <div className="dw-quote-item">
      <span className="dw-quote-check">✓</span>
      <span>50+ Projects Completed</span>
    </div>
  </div>

  <div className="col-12">
    <div className="dw-quote-item">
      <span className="dw-quote-check">✓</span>
      <span>100+ Satisfied Clients</span>
    </div>
  </div>

  <div className="col-12">
    <div className="dw-quote-item">
      <span className="dw-quote-check">✓</span>
      <span>60+ Skilled Workers</span>
    </div>
  </div>

  <div className="col-12">
    <div className="dw-quote-item">
      <span className="dw-quote-check">✓</span>
      <span>12+ Years of Experience</span>
    </div>
  </div>

              </div>

                {/* <Link to="/estimate">
                  <button className="dw-quote-btn">Calculate my Cost</button>
                </Link> */}
              </div>
            </div>

            {/* <div className="col-lg-6">
              <div className="dw-quote-img-wrap">
                <img src={building2} alt="building" className="dw-quote-img" />
              </div>
            </div> */}


<div className="col-lg-5">
  <div className="dw-form-wrap">

 {/* NEW HEADING  */}
    <div className="ce-form-header">
      <h2>Calculate my Cost</h2>
      <p>Fill in your project details and discover the estimated cost instantly.</p>
    </div>

    <div className="ce-card">
              <h3>Property Type </h3>
              <p className="para"> Select your property type to help us understand your project requirements</p>

              {/* Open Plot and Non-Approved Property Radio Buttons */}

              <div className="ce-radio-group">
                <label className="ce-radio-label">
                  <input
                    type="radio"
                    name="propertyType"
                    value="openPlot"
                    checked={data.openPlot}
                    onChange={(e) =>
                      setData({
                        ...data,
                        openPlot: true,
                        nonApprovedProperty: false,
                        areaInputType: "",
                      })
                    }
                  />
                  <span className="ce-radio-custom"></span>
                  <div>
                    <strong>Open Plot</strong>
                    <p>A plot without layout approval or subdivision</p>
                  </div>
                </label>

                <label className="ce-radio-label">
                  <input
                    type="radio"
                    name="propertyType"
                    value="nonApproved"
                    checked={data.nonApprovedProperty}
                    onChange={(e) =>
                      setData({
                        ...data,
                        nonApprovedProperty: true,
                        openPlot: false,
                        areaInputType: "",
                      })
                    }
                  />
                  <span className="ce-radio-custom"></span>
                  <div>
                    <strong>NA Approved Layout</strong>
                    <p>Plot within an approved non-agricultural layout</p>
                  </div>
                </label>
              </div>

              {/* Open Plot Input Fields - Show when Open Plot is selected */}

              {data.openPlot && (
                <div className="ce-open-plot-section">
                  <h4>Open Plot Details</h4>

                  <div className="ce-input-type-selector">
                    <label className="ce-input-type-radio">
                      <input
                        type="radio"
                        name="areaInputType"
                        value="lengthWidth"
                        checked={data.areaInputType === "lengthWidth"}
                        onChange={(e) =>
                          setData({ ...data, areaInputType: e.target.value })
                        }
                      />
                      <span className="ce-radio-dot"></span>I know Length and
                      Width
                    </label>

                    <label className="ce-input-type-radio">
                      <input
                        type="radio"
                        name="areaInputType"
                        value="area"
                        checked={data.areaInputType === "area"}
                        onChange={(e) =>
                          setData({ ...data, areaInputType: e.target.value })
                        }
                      />
                      <span className="ce-radio-dot"></span>I know Total Area
                    </label>
                  </div>

                  {data.areaInputType === "lengthWidth" && (
                    <>
                      <div className="ce-field ce-float">
                        <select
                          name="openPlotLengthWidthUnit"
                          value={data.openPlotLengthWidthUnit}
                          onChange={handle}
                          required
                        >
                          <option value="Feet">Feet</option>
                          <option value="Meter">Meter</option>
                        </select>
                        <label>Unit</label>
                      </div>

                      <div className="ce-input-row">
                        <div className="ce-field ce-field-half ce-no-spinner">
                          <input
                            type="number"
                            name="openPlotLength"
                            value={data.openPlotLength}
                            onChange={handle}
                            placeholder=""
                            min="0"
                            step="0.01"
                          />
                          <label>Length ({data.openPlotLengthWidthUnit})</label>
                        </div>

                        <div className="ce-field ce-field-half ce-no-spinner">
                          <input
                            type="number"
                            name="openPlotWidth"
                            value={data.openPlotWidth}
                            onChange={handle}
                            placeholder=""
                            min="0"
                            step="0.01"
                          />
                          <label>Width ({data.openPlotLengthWidthUnit})</label>
                        </div>
                      </div>
                    </>
                  )}

                  {data.areaInputType === "area" && (
                    <>
                      <div className="ce-field ce-float">
                        <select
                          name="openPlotAreaUnit"
                          value={data.openPlotAreaUnit}
                          onChange={handle}
                          required
                        >
                          <option value="sq.ft">sq.ft</option>
                          <option value="sq.meter">sq.meter</option>
                        </select>
                        <label>Unit</label>
                      </div>

                      <div className="ce-field ce-no-spinner">
                        <input
                          type="number"
                          name="openPlotArea"
                          value={data.openPlotArea}
                          onChange={handle}
                          placeholder=""
                          min="0"
                          step="0.01"
                        />
                        {/* <span 
className="ce-input-addon ce-input-addon-clickable"
onClick={() => setData({...data, openPlotAreaUnit: data.openPlotAreaUnit === "sq.ft" ? "sq.meter" : "sq.ft"})}
title="Click to toggle between sq.ft and sq.meter"
>
{data.openPlotAreaUnit === "sq.ft" ? "sq.ft" : "sq.m"}
</span> */}
                        {/* <label>Total Area ({data.openPlotAreaUnit})</label> */}
                        <label>Total Area ({data.openPlotAreaUnit})</label>
                      </div>
                    </>
                  )}
                </div>
              )}

              {data.nonApprovedProperty && (
                <>
                  {/* Society */}

                  <div className="ce-field">
                    <input
                      type="text"
                      name="society"
                      value={data.society}
                      onChange={handle}
                      placeholder=" "
                      required
                    />

                    <label>Enter Society Name</label>
                  </div>

                  {/* Plot Number (same floating input) */}

                  <div className="ce-field">
                    <input
                      type="text"
                      name="plot"
                      value={data.plot}
                      onChange={handle}
                      placeholder=" "
                      required
                    />

                    <label>Enter Plot Number</label>
                  </div>

                  {/* Building Type (dropdown floating) */}

                  <div className="ce-field ce-float">
                    <select
                      name="buildingType"
                      value={data.buildingType}
                      onChange={handle}
                      required
                    >
                      <option value=""></option>
                      <option value="RowHouse">Row House</option>
                      <option value="TwinBungalow">Twin Bungalow</option>
                      <option value="IndependentBungalow">
                        Independent Bungalow
                      </option>
                      <option value="ResidentialApartment">
                        Residential Apartment
                      </option>
                      <option value="StudioApartment">Studio Apartment</option>
                      <option value="custom">Custom</option>
                    </select>

                    <label>Select Building Type</label>
                  </div>
                </>
              )}

              {/* Custom textbox */}

              {/* {data.buildingType === "custom" && (

<div className="ce-field">

<input
type="text"
name="customBuildingType"
value={data.customBuildingType}
onChange={handle}
placeholder=" "
/>

<label>Enter Custom Building Type</label>

</div>

)} */}

              {data.buildingType === "custom" && (
                <div className="ce-field ce-float">
                  <select
                    name="customBuildingType"
                    value={data.customBuildingType}
                    onChange={handle}
                    required
                  >
                    <option value=""></option>
                    <option value="Residential">Residential</option>
                    <option value="Commercial">Commercial</option>
                    <option value="MixedUse">Mixed Use</option>
                    <option value="Hospital">Hospital</option>
                  </select>

                  <label>Select Custom Building Type</label>
                </div>
              )}

            <div className="ce-btn-row">

  <button
    className="ce-btn"
    disabled={
      !data.openPlot && !data.nonApprovedProperty
        ? true
        : data.openPlot
          ? !data.areaInputType ||
            (data.areaInputType === "lengthWidth" &&
              (!data.openPlotLength || !data.openPlotWidth)) ||
            (data.areaInputType === "area" && !data.openPlotArea)
          : !data.society || !data.plot || !data.buildingType
    }
    onClick={nextStep}
  >
    Next
  </button>

</div>
            </div>
</div>
</div>

          </div>
        </div>
      </section>


<ProjectsGrid/>

     {/* ================= VIDEO SECTION START ================= */}

{/*
<section className="dw-video-carousel-section">
  <div className="container-fluid px-0">
    <div className="dw-video-carousel-heading text-center">
      <div className="dw-video-carousel-heading text-center animate-corner">
        <h2 className="corner-left">Video LOREM ISPUM LOREM</h2>

        <p className="corner-right">
          Lorem ipsum dolor sit amet, consecte adipisicing elit. Sed do eiusmod <br />
          tempor incididunt ut labore et dolore magna
        </p>
      </div>
    </div>

    <div className="dw-video-carousel-wrapper">
      <Splide options={splideOptions} className="dw-video-splide">
        {videoData.map((item) => (
          <SplideSlide key={item.id}>
            <div className="dw-video-slide">
              <video src={item.video}></video>

              <button className="dw-video-play-btn" onClick={playActiveVideo}>
                ▶
              </button>

              <div className="dw-video-overlay">{item.text}</div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  </div>
</section>
*/}

{/* ================= VIDEO SECTION END ================= */}

  {/* REVIEW SECTION */}
{/* <section className="dw-review-section">
  <div className="container-fluid p-0">

    <h2 className="dw-review-heading text-center">
      {text}
      <span className="dw-type-cursor">_</span>
    </h2>

    <div className="dw-review-carousel-wrapper">
      <Splide
  options={{
    type: "loop",
    focus: "center",
    autoWidth: true,
    gap: "5px",
    pagination: false,
    arrows: true,
    speed: 300,
    breakpoints: {
      992: {
        autoWidth: false,
        perPage: 1,
        
      },
    },
  }}
  className="dw-review-splide"
>
        {reviewData.map((review) => (
          <SplideSlide key={review.id}>
            <div className="dw-review-card-new">
              <p className="dw-review-text">{review.text}</p>

              <div className="dw-review-user">
                <img src={review.img} alt={review.name} />
                <div>
                  <h6>{review.name}</h6>
                  <div className="dw-review-stars">★★★★★</div>
                </div>
              </div>
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  </div>
</section> */}



{/* ================= REVIEW SECTION ID style ================= */}

{/* <section className="dw-review-section">
  <div className="container-fluid p-0">

   
    <h2 className="dw-review-heading text-center">
      {text}
      <span className="dw-type-cursor">_</span>
    </h2>

    <div className="dw-review-carousel-wrapper">

      <Splide
        options={{
          type: "loop",
          focus: "center",
          autoWidth: true,
          gap: "30px",
          pagination: false,
          arrows: true,
          speed: 800,
          breakpoints: {
            992: {
              autoWidth: false,
              perPage: 1,
            },
          },
        }}
        className="dw-review-splide"
      >

        {reviewData.map((review) => (
          <SplideSlide key={review.id}>

            <div className="dw-review-card-new">

             
              <div className="dw-review-left">
                <img src={review.img} alt={review.name} />
                <h6>{review.name}</h6>
                <div className="dw-review-stars">★★★★★</div>
              </div>

            
              <div className="dw-review-right">
                <p className="dw-review-text">
                  {review.text}
                </p>
              </div>

            </div>

          </SplideSlide>
        ))}

      </Splide>

    </div>
  </div>
</section> */}




      {/* HOW IT WORKS SECTION */}
      <section className="dw-how-section">
        <div className="container">
          <div className="dw-how-heading text-center">
            <h2>HOW IT WORKS</h2>
            <p>
             From concept to completion, our streamlined design and construction process ensures transparency, expert guidance, and timely delivery — so you experience a smooth and stress-free journey from day one.
            </p>
          </div>

          <div className="dw-how-wrapper">
            <div className="dw-how-line"></div>

            <div className="row dw-how-row">
              <div className="col-lg-4 col-md-4 col-sm-12 dw-how-step">
                <div className="dw-how-circle">1</div>
                <h5>Raise a Request</h5>
                <p>Share your space details, requirements, and budget. We carefully understand your vision before moving ahead..</p>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 dw-how-step">
                <div className="dw-how-circle">2</div>
                <h5>Meet our Expert</h5>
                <p>Consult with our design and construction specialists for practical, cost-effective solutions tailored to you.</p>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 dw-how-step">
                <div className="dw-how-circle">3</div>
                <h5>Book with us</h5>
                <p>Finalize scope, pricing, and timelines with complete transparency and zero hidden costs.</p>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 dw-how-step">
                <div className="dw-how-circle">4</div>
                <h5>Receive Plans</h5>
                <p>Get detailed layouts and 3D designs crafted to match your style and functional needs.</p>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 dw-how-step">
                <div className="dw-how-circle">5</div>
                <h5>Track and Transact</h5>
                <p>Monitor project progress with milestone updates and structured payment stages.</p>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-12 dw-how-step">
                <div className="dw-how-circle">6</div>
                <h5>Settle in</h5>
                <p>Experience timely handover, premium quality, and a beautifully finished space ready to enjoy.</p>
              </div>
            </div>

            {/* <div className="dw-how-btn-wrap text-center">
              <button onClick={openContactModal} className="dw-how-btn">
               Let’s consult <span className="dw-arrow1">&#x203A;</span> 
              </button>
            </div> */}



            <div className="dw-how-btn-wrap text-center">
               <button onClick={openContactModal} className="hero-btn1">
  <span className="btn-text">Let’s Consult</span>
  <span className="btn-arrow">&#x203A;</span>
</button>
            </div>

            
          </div>
        </div>
      </section>

    
{/* <ReviewSection/> */}

 <section className="dw-review-section">
  <div className="container-fluid p-0">

    <h2 className="dw-review-heading text-center">
      {text}
      <span className="dw-type-cursor">_</span>
    </h2>

    <div className="dw-review-carousel-wrapper">
      <Splide
  options={{
    type: "loop",
    focus: "center",
    autoWidth: true,
    gap: "1px",
    pagination: false,
    arrows: true,
    speed: 300,
    breakpoints: {
      992: {
        autoWidth: false,
        perPage: 1,
        
      },
    },
  }}
  className="dw-review-splide"
>
        {reviewData.map((review) => (
          <SplideSlide key={review.id}>
           <div className="dw-review-card-new">

  {/* LEFT */}
  <div className="dw-review-left">
    <img src={review.img} alt={review.name} />
    <h6 className="dw-review-name">{review.name}</h6>
    <div className="dw-review-stars">★★★★★</div>
  </div>

  {/* RIGHT */}
  <p className="dw-review-text">{review.text}</p>

</div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  </div>
</section> 

{/* <DwServicesCarousel /> */}

      {/* OUR SERVICES SECTION */}
      <section id="services" className="dw-services-section">
        <div className="container ">
          <div className="dw-services-heading text-center">
            <h2>Our Services</h2>
            <p>
              Dwellora Homes are the one stop solution in real estate industry and have executed 
              many recognized projects across Maharashtra
            </p>
          </div>

          <div className="dw-services-slider-wrapper">
            <div className="swiper dw-service-swiper">
              <div className="swiper-wrapper">

                <div className="swiper-slide">
                  <div className="dw-service-card">
                    <div className="dw-service-img-wrapper"> 
                    {/* <img src="image/ser1.png" alt="service" className="dw-service-img" /> */}
                    <img src={ser1} alt="service" className="dw-service-img" />
                    </div>
                    <div className="dw-service-content">
                      <h5>Architecture <br/>Design Services</h5>
                      <p>Personalized home designs that are beautiful, functional, and practical. We turn ideas into blueprints.</p>
                     
<Link to="/architecture" className="dw-service-link mt-2 mb-2">
  Start My Custom Design
  <span className="arrow-service">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="16"
      viewBox="0 0 40 16"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" y1="8" x2="32" y2="8" />
      <polyline points="26 3 32 8 26 13" />
    </svg>
  </span>
</Link>

                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="dw-service-card">
                      <div className="dw-service-img-wrapper"> 
                    {/* <img src="image/service-image/liasoning-image.png" alt="service" className="dw-service-img" /> */}
<img src={liasoningImg} alt="service" className="dw-service-img" />

                    </div>
                    <div className="dw-service-content">
                      <h5>Liasioning - Design <br/> approvals</h5>
                      <p>We take care of all necessary<br/> permissions from  PMC, PCMC, and PMRDA, saving you time and stress.</p>
                    <Link to="/liaisoning" className="dw-service-link mt-2 mb-2">
  Get My Plans Approved
  <span className="arrow-service">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="16"
      viewBox="0 0 40 16"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" y1="8" x2="32" y2="8" />
      <polyline points="26 3 32 8 26 13" />
    </svg>
  </span>
</Link>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="dw-service-card">
                      <div className="dw-service-img-wrapper"> 
                    {/* <img src="image/ser-turnkey.png" alt="service" className="dw-service-img" /> */}
                    <img src={serTurnkey} alt="service" className="dw-service-img" />
                    </div>
                    <div className="dw-service-content">
                      <h5>Complete Turnkey <br/>Construction Solutions</h5>
                      <p>Quality construction with attention to detail. We use reliable materials and offer site supervision for peace of mind.</p>
                     <Link to="/construction" className="dw-service-link mt-2 mb-2">
  Let's Building My Home
  <span className="arrow-service">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="16"
      viewBox="0 0 40 16"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" y1="8" x2="32" y2="8" />
      <polyline points="26 3 32 8 26 13" />
    </svg>
  </span>
</Link>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="dw-service-card">
                      <div className="dw-service-img-wrapper"> 
                    {/* <img src="image/ser4.png" alt="service" className="dw-service-img" /> */}
                    <img src={ser4} alt="service" className="dw-service-img" />
                    </div>
                    <div className="dw-service-content">
                      <h5>Interior Design <br/> Services</h5>
                      <p>From cozy living rooms to smart kitchens, we bring your interiors to life with aesthetics, comfort, and creativity.</p>
                   <Link to="/interior" className="dw-service-link mt-2 mb-2">
  Style My Interiors 
  <span className="arrow-service">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="16"
      viewBox="0 0 40 16"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" y1="8" x2="32" y2="8" />
      <polyline points="26 3 32 8 26 13" />
    </svg>
  </span>
</Link>
                    </div>
                  </div>
                </div>

                <div className="swiper-slide">
                  <div className="dw-service-card">
                      <div className="dw-service-img-wrapper"> 
                    {/* <img src="image/ser4.png" alt="service" className="dw-service-img" /> */}
                    <img src={pmcImg} alt="service" className="dw-service-img" />
                    </div>
                    <div className="dw-service-content">
                      <h5>PMC (Project Management Consultancy)</h5>
                      <p> End-to-end construction support to manage your project smoothly from planning to final execution.</p>
                   <Link to="/pmc" className="dw-service-link mt-2 mb-2">
  Manage My Project 
  <span className="arrow-service">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="16"
      viewBox="0 0 40 16"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="2" y1="8" x2="32" y2="8" />
      <polyline points="26 3 32 8 26 13" />
    </svg>
  </span>
</Link>
                    </div>
                  </div>
                </div>



              </div>
            </div>

            {/* SERVICE NAV BUTTONS */}
            {/* <div className="dw-service-nav">
  <button className="dw-service-btn dw-service-prev">
    <span className="arrow">&#10094;</span>
  </button>
  <button className="dw-service-btn dw-service-next">
    <span className="arrow">&#10095;</span>
  </button>
</div> */}

<div className="dw-service-nav">
  <button className="dw-service-btn dw-service-prev">
    <span className="arrow">←</span>
  </button>

  <button className="dw-service-btn dw-service-next">
    <span className="arrow">→</span>
  </button>
</div>
          </div>
        </div>
      </section>


     <Footer 
  openContactModal={openContactModal}
  showCTA={showCTA} 
/>
    
    </div>
    </>

  );
}

export default Home;

